export default __webpack_public_path__ + "static/media/Profile Image.fe946d1c.png";